export default __webpack_public_path__ + "static/media/ToyotaType-BookIt.9581f718.ttf";